import React from 'react';
import AppBody from './components/AppBody';
import Navbar from './components/Navbar';
import { ScrollTop } from 'primereact/scrolltop';

export default function App(){
    return(
        <>
        <Navbar/>
        <ScrollTop threshold={100}/>
        <AppBody/>
        
        </>
    )
}